import React, { useState } from 'react';
import './ContactUs.css'
import axios from 'axios';
import Swal from 'sweetalert2';
import { SERVER_URL } from '../../../ServerUrl';

const ContactUs = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [message, setMessage] = useState('');


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!firstName || !lastName || !email || !phoneNumber || !message) {
            Swal.fire({
                icon: 'error',
                text: 'Please fill all fields to send message',
            });
            return;
        }
        const emailData = {
            firstName: firstName,
            lastName: lastName,
            email: email,
            phoneNumber: phoneNumber,
            message: message
        };
        try {
            const response = await axios.post(`${SERVER_URL}/email/send-email`, emailData);

            if (response.data.success) {
                // Display success message with appointment details
                Swal.fire({
                    icon: 'success',
                    title: 'Email sent',
                });


                setEmail('');
                setMessage('');
                setFirstName('');
                setLastName('');
                setPhoneNumber('');
            } else {
                console.error('Failed to send email.');
                // Handle failure, e.g., show an error message to the user
            }
        } catch (error) {
            if (error.response && error.response.data.message) {
                Swal.fire({
                    icon: 'error',
                    text: error.response.data.message,
                });
            } else {
                console.error('Error sending email:', error);
            }
            // Handle error, e.g., show an error message to the user
        }
    };
    return (
        <>
            <div className='pageMain'>
                <img src={require('../../assets/newcontact.jpg')} className=' backImage' alt="" />
                <div className='centerOuter'>

                    <div className='formSection'>
                        <div className=' dontText '>
                            Contact Us
                        </div>
                        <div className='flex justify-between w-full '>
                            <input
                                type="text"
                                className='nameInput'
                                placeholder='First Name*'
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                            />
                            <input
                                type="text"
                                className='nameInput'
                                placeholder='Last Name*'
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                            />
                        </div>
                        <input
                            type="text"
                            className='emailInput'
                            placeholder='Email*'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <input
                            type="number"
                            className='emailInput'
                            placeholder='Phone Number*'
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                        />
                        <textarea
                            className='measageArea'
                            placeholder='Your message...'
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                        ></textarea>
                        <button className='messageBtn' onClick={handleSubmit}>Send Message</button>
                    </div>
                    <div className="contactRightSection">
                        <div className="nameOfCompany"><span className="companyNameText">Company Name:</span>{" "} BUS ARABIA - FZCO</div>
                        <div className="nameOfCompany"><span className="companyNameText">E-mail address:</span>{" "} customercare@busarabia.com</div>
                        <div className="nameOfCompany"><span className="companyNameText">Phone Number:</span>{" "} 00971502461426</div>
                        <div className="nameOfCompany"><span className="companyNameText">P.O Box:</span>{" "} 342001</div>
                        <div className="nameOfCompany"><span className="companyNameText">Address:</span>{" "}  Building A1, Dubai Digital Park, <br /> Dubai Silicon Oasis, Dubai, United Arab Emirates</div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactUs
